import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SuggestionsState {
  sellerId?: string | null;
  query: string;
  isLoading: boolean;
  suggestions: any[];
  error: string | null;
}

const initialState: SuggestionsState = {
  sellerId: null, // Optional sellerId, can be set later if needed
  query: "",
  isLoading: false,
  suggestions: [],
  error: null,
};

export const suggestionsSlice = createSlice({
  name: "suggestions",
  initialState,
  reducers: {
    getSuggestionsStart: (state, action: PayloadAction<{ query: string; sellerId: string | null }>) => {
      state.isLoading = true;
      state.error = null;
      state.query = action.payload.query;
      state.sellerId = action.payload.sellerId;
    },
    getSuggestionsSuccess: (state, action: PayloadAction<any[]>) => {
      state.isLoading = false;
      state.suggestions = action.payload;
      state.error = null;
    },
    getSuggestionsFailure: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    // If you want to reset suggestions explicitly
    resetSuggestions: (state) => {
      state.suggestions = [];
      state.error = null;
      state.isLoading = false;
    },
  },
});

export const {
  getSuggestionsStart,
  getSuggestionsSuccess,
  getSuggestionsFailure,
  resetSuggestions,
} = suggestionsSlice.actions;

export default suggestionsSlice.reducer;
